// All website forms now post straight into the Vijay Primes CRM
// (crm.vijayprimes.com) — every submission shows up there as an Enquiry
// (Source: Website) or, for "Join Us as Partner", as a new Channel Partner.
//
// CRM_ORG_SLUG = your organization's slug in the CRM. Loose match is fine:
// "vijayprimes", "vijay-primes" and "VijayPrimes" all resolve to the same org.
//
// Old backend (no longer used):
// const BASE_URL = 'https://admin.vijayprimes.com/api/app/';

const CRM_API = 'https://api-crm.vijayprimes.com/api';
// const CRM_API = 'http://127.0.0.1:8000/api';   // local CRM backend
const CRM_ORG_SLUG = 'vijayprimes';

const BASE_URL = `${CRM_API}/leads/public/website/${CRM_ORG_SLUG}/`;

export const API_ENDPOINTS = {
  CREATELOANREQUEST: `${BASE_URL}loan-request/`,
  CREATECALLBACKREQUEST: `${BASE_URL}callback-request/`,
  CREATECONTACTREQUEST: `${BASE_URL}contact-request/`,
  CREATEPARTNERREQUEST: `${BASE_URL}partner-request/`,
};

export default API_ENDPOINTS;